import React from 'react';
import { View, Image } from '@react-pdf/renderer';

function DisplayArgoTables(props) {
  const { svgData } = props;

  return (
    <>

      {svgData.map((svg, index) => (
        <View key={index} style={{ marginBottom: 20 }}>
          <View style={{ marginTop: 0, marginLeft: 10 }}>
            <Image src={svg} style={{ width: '100%' }} />
          </View>
        </View>
      ))}
    </>
  );
}

export default DisplayArgoTables;